import * as React from 'react'
import styled from '@theme/styled-components'

interface Props {
  title: string
  placeholder: string
  value: string
  onChange: (txt: string) => void
  nonEditable?: boolean
  error?: string
}

const TextInput = ({ title, placeholder, value, onChange, nonEditable = false, error }: Props) => {
  return (
    <InputContainer>
      <InputTitle>{title}</InputTitle>
      <Input
        disabled={nonEditable}
        value={value}
        onChange={(evt) => onChange(evt.target.value)}
        placeholder={placeholder}></Input>
      <ErrorLibelle>{error}</ErrorLibelle>
    </InputContainer>
  )
}

export default TextInput

const InputContainer = styled('div')`
  display: flex;
  flex: 1;
  flex-direction: column;

  margin: 5px;
`
const InputTitle = styled('div')`
  font-family: Avenir;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;
  color: #9494a2;
`
const Input = styled('input')<{ disabled: boolean }>`
  display: flex;
  flex: 1;
  min-height: 50px;
  background: ${(props) => (props.disabled ? '#CCCCCC' : '#FFFFFF')};
  ${(props) => props.disabled && `cursor: not-allowed;`}
  border: 1px solid #747474;
  box-sizing: border-box;
  border-radius: 7px;

  font-family: Avenir;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #6a6a6a;
  padding: 0 10px;
`
const ErrorLibelle = styled('div')`
  ${(props) => props.theme.fonts.errorLibelle};
  text-align: center;
  margin-top: 10px;
  height: 20px;
`
